export const bannerEntitiesPaths = {
    //    discounts: "Descuento",
    lines: "Categoría",
    collections: "Colección",
    brands: "Marca",
    products: "Producto",
    custom: "Redirección personalizada",
    undefined: "Sin redirección"
};

export const entitiesUploadImage = {
    reference: "Variante",
    line: "Categoría"
};
